import facebook from './facebook.svg';
import github from './github.svg';
import google from './google.svg';
import linkedin from './linkedin.svg';
import microsoft from './microsoft.svg';
import twitter from './twitter.svg';

const icons = {
  facebook: facebook,
  github: github,
  google: google,
  linkedin: linkedin,
  microsoft: microsoft,
  twitter: twitter,
};

export default icons;
